var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useRef, useState } from 'react';
import { Pressable } from 'react-native';
import { WHITE } from '../../constants';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { Typography } from '../typography';
import { getButtonIconStyle, getFloatingActionButtonProps, getFloatingActionButtonStyles } from './FloatingActionButtonStyles';
export var FloatingActionButton = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var floatingActionButtonProps = getFloatingActionButtonProps(props, stateContext);
  var title = floatingActionButtonProps.title,
    iconName = floatingActionButtonProps.iconName,
    iconProps = floatingActionButtonProps.iconProps,
    iconOnly = floatingActionButtonProps.iconOnly,
    _floatingActionButton = floatingActionButtonProps.size,
    size = _floatingActionButton === void 0 ? 'sm' : _floatingActionButton,
    style = floatingActionButtonProps.style,
    _onPress = floatingActionButtonProps.onPress,
    _floatingActionButton2 = floatingActionButtonProps.testID,
    testID = _floatingActionButton2 === void 0 ? 'FloatingActionButton' : _floatingActionButton2,
    restProps = __rest(floatingActionButtonProps, ["title", "iconName", "iconProps", "iconOnly", "size", "style", "onPress", "testID"]);
  var stylesBasedOnState = useRef();
  var _useState = useState(0),
    width = _useState[0],
    setWidth = _useState[1];
  var getFloatingButtonPressableStyles = useCallback(event => {
    var styles = getFloatingActionButtonStyles(event, floatingActionButtonProps, width);
    stylesBasedOnState.current = styles;
    return [styles.container, style];
  }, [floatingActionButtonProps]);
  return _jsxs(Pressable, Object.assign({
    ref: ref,
    accessibilityRole: "button",
    style: getFloatingButtonPressableStyles,
    onPress: event => {
      _onPress === null || _onPress === void 0 ? void 0 : _onPress(event);
    },
    onLayout: data => {
      var _a, _b;
      setWidth((_b = (_a = data === null || data === void 0 ? void 0 : data.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.width);
    }
  }, restProps, getTestId(testID), {
    children: [!!iconName && _jsx(DynamicSvg, Object.assign({
      iconName: iconName,
      color: WHITE,
      fontSize: size == 'md' ? 24 : 20,
      style: getButtonIconStyle(floatingActionButtonProps)
    }, iconProps, getTestId(testID, 'icon'))), !iconOnly && _jsx(Typography, Object.assign({
      text: title,
      type: "body-single-line-" + (size == 'md' ? 'md' : 'sm') + "-bold",
      color: WHITE
    }, getTestId(testID, 'title')))]
  }));
});